import { useEffect, useCallback, useState } from 'react';
import { useHistory, useLocation } from 'quartz-routing/react-router';
import { Flex } from 'foundations-components/components/Flex';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { AcademyAIAssistantChatContainer } from 'academy-ai-assistant-lib/components/AcademyAIAssistantChatContainer';
import { useHasGate } from '../features/accounts/accountsQueries';
import UsageTracker from '../utils/UsageTracker';
import { SCREENS } from '../constants/Tracking';
import { jsx as _jsx } from "react/jsx-runtime";
const AcademyAssistant = () => {
  const {
    hasGate
  } = useHasGate('Academy:AiAssistant');
  const history = useHistory();
  const location = useLocation();
  const [initialPrompt] = useState(() => {
    var _location$state;
    return (_location$state = location.state) === null || _location$state === void 0 ? void 0 : _location$state.initialPrompt;
  });
  useEffect(() => {
    var _location$state2;
    if ((_location$state2 = location.state) !== null && _location$state2 !== void 0 && _location$state2.initialPrompt) {
      history.replace(location.pathname, {});
    }
  }, [history, location.pathname, location.state]);
  useEffect(() => {
    if (hasGate) {
      UsageTracker.trackStandalone('Pageview', {
        screen: SCREENS.ACADEMY_ASSISTANT
      });
    }
  }, [hasGate]);
  const handleClose = useCallback(() => {
    history.push('/');
  }, [history]);
  if (!hasGate) return null;
  return /*#__PURE__*/_jsx(Flex, {
    blockSize: "calc(100vh - 100px)",
    flexDirection: "column",
    overflow: "hidden",
    padding: "400",
    children: /*#__PURE__*/_jsx(CardWrapper, {
      borderRadius: "400",
      borderWidth: "0",
      flexGrow: 1,
      padding: "400",
      children: /*#__PURE__*/_jsx(AcademyAIAssistantChatContainer, {
        initialPrompt: initialPrompt,
        onClose: handleClose
      })
    })
  });
};
export default AcademyAssistant;